import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { Typography, Box, Link as MuiLink } from '@mui/material';
import VolunteerActivismRoundedIcon from '@mui/icons-material/VolunteerActivismRounded';
import WorkIcon from '@mui/icons-material/Work';
import './Experience.css';

const experiences = [
  {
    title: 'Software Volunteer',
    organization: 'AIRE CEI Foundation',
    organizationUrl: 'https://comiteecologicointegral.org/acerca-de-ceiaire/',
    date: 'December 2022 - February 2023',
    location: 'Monterrey, Mexico',
    highlights: [
      'Implemented a responsive web dashboard that expanded access to local air quality data.',
      'Partnered with environmental scientists to translate sensor readings into actionable alerts.',
    ],
  },
  {
    title: 'Product & Engineering Volunteer',
    organization: 'Colaborar.mx',
    organizationUrl: 'https://colaborar.mx/',
    date: 'August 2022 - December 2023',
    location: 'Monterrey, Mexico',
    highlights: [
      'Built full-stack features that enabled social impact teams to coordinate resources in real time.',
      'Introduced analytics that helped the nonprofit measure collaboration opportunities across cities.',
    ],
  },
  {
    title: 'Frontend Volunteer',
    organization: 'Creesiendo Foundation',
    organizationUrl: 'https://www.instagram.com/creesiendomx/',
    date: 'September 2022 - November 2022',
    location: 'Monterrey, Mexico',
    highlights: [
      'Designed and shipped a welcoming landing page to increase awareness of early childhood programs.',
      'Simplified the donation experience and clarified program impact stories.',
    ],
  },
  {
    title: 'Data Volunteer',
    organization: 'CLISA Foundation',
    organizationUrl: 'https://www.grupoclisa.com.mx/Sites/fundacionclisa/index.html',
    date: 'February 2022 - June 2022',
    location: 'Monterrey, Mexico',
    highlights: [
      'Created data ingestion scripts that helped track eye care services for low-income communities.',
      'Automated reporting to support outreach clinics and volunteer scheduling.',
    ],
  },
];

const VolunteerExperience = () => {
  return (
    <Box>
      <Typography variant="overline" sx={{ color: 'secondary.light', letterSpacing: 2 }}>
        Community impact
      </Typography>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
        Volunteer Experience
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 640, mb: 4 }}>
        Building technology that serves communities has been a through line in my work. These
        collaborations taught me how to ground design decisions on empathy and measurable outcomes.
      </Typography>

      <VerticalTimeline>
        {experiences.map((exp, index) => (
          <VerticalTimelineElement
            key={index}
            date={exp.date}
            icon={index === 0 ? <VolunteerActivismRoundedIcon /> : <WorkIcon />}
            iconStyle={{
              background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.95), rgba(249, 115, 22, 0.85))',
              color: '#020617',
            }}
            contentStyle={{
              background: 'rgba(15, 23, 42, 0.85)',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              boxShadow: '0 20px 60px rgba(15, 23, 42, 0.35)',
              borderRadius: '16px',
              color: '#e2e8f0',
            }}
            contentArrowStyle={{ borderRight: '7px solid rgba(30, 41, 59, 0.85)' }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
              <Typography variant="h6" component="h3">
                {exp.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {exp.location}
              </Typography>
            </Box>
            <Typography
              variant="subtitle1"
              component="p"
              sx={{ fontStyle: 'italic', marginTop: 1, color: 'text.secondary' }}
            >
              <MuiLink
                href={exp.organizationUrl}
                target="_blank"
                rel="noopener noreferrer"
                underline="hover"
                sx={{ color: 'inherit' }}
              >
                {exp.organization}
              </MuiLink>
            </Typography>
            <Typography variant="body2" component="div" sx={{ color: 'text.secondary', mt: 1.5 }}>
              <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                {exp.highlights.map((item, idx) => (
                  <li key={idx} style={{ marginBottom: '0.5rem' }}>
                    {item}
                  </li>
                ))}
              </ul>
            </Typography>
          </VerticalTimelineElement>
        ))}
      </VerticalTimeline>
    </Box>
  );
};

export default VolunteerExperience;
